<!--page starts-->
<section class="page-wrapper">
    <div class="event-hero-section margin-top-152 cf">

        <div class="container">
            <div class="event-hero-detail">
                <div class="event-hero-titel">
                    <h2>{{evnetList?.title}}</h2>
                    <p>THE PERFECT VENUE FOR BUSINESS OR PLEASURE</p>
                </div>
                <div class="event-hero-list-box">
                    <div class="event-hero-tab-list-detail">
                        <ul *ngIf="evnetList?.event_title?.length > 0">
                            <li *ngFor="let events of evnetList?.event_title; let i = index"><a
                                href="/event/{{storeurl}}/{{events?.slug}}" (click)="tabactive(events?.event_title_id, events?.title)"
                                    class="courses-name banner-name" [ngClass]="{ active: events?.slug == currenttab }"
                                    id="evnet-{{events?.event_title_id}}" rel="{{events?.slug}}">{{events?.title}}</a></li>
                            <!-- <li><a href="javascript:void(0)" class="courses-name active" id="conference-event"> CONFERENCES & EVENTS </a></li>
                            <li><a href="javascript:void(0)" class="courses-name " id="suites">SUITES</a></li>
                            <li><a href="javascript:void(0)" class="courses-name " id="corporate-days">Corporate Days</a></li>
                            <li><a href="javascript:void(0)" class="courses-name " id="weddings">Weddings</a></li>                                 -->
                        </ul>
                    </div>
                    <div class="event-hero-mouse">
                        <div class="event-hero-mouse-img">
                            <a href="javascript:void(0)">
                                <img src="assets/images/mouse.svg">
                            </a>
                        </div>
                        <p>scroll for details</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="header-left-social-icon dsk">
            <ul>
                <li><a href="https://www.facebook.com/leicsccc" target="_blank"><img src="assets/images/fb.svg"
                            alt="fb"></a></li>
                <li><a href="https://instagram.com/leicsccc" target="_blank"><img src="assets/images/insta.svg"
                            alt="insta"></a></li>
                <li><a href="https://www.youtube.com/user/leicestershireccc1/videos" target="_blank"><img
                            src="assets/images/youtube.svg" alt="youtube"></a></li>
                <li><a href="http://www.twitter.com/leicsccc" target="_blank"><img src="assets/images/twi.svg"
                            alt="twi"></a></li>
            </ul>
        </div>
        <div class="event-hero-overlay"></div>
        <div class="event-hero-section-overlay banner-top-content" [ngClass]="{ active: events?.slug == currenttab }"
            id="evnet-{{events?.event_title_id}}-contentimg" *ngFor="let events of evnetList?.event_title; let i = index"
            [ngStyle]="{'background-image':'url(' + events?.image + ')'}"></div>
    </div>

    <div class="event-center-section course-main-content event-center-top  " [ngClass]="{ active: events?.slug == currenttab }"
        id="evnet-{{events?.event_title_id}}-content" *ngFor="let events of evnetList?.event_title; let i = index">
        <div class="container">
            <div class="event-center-detail cf">
                <div class="event-outdoor-tab-list-detail">
                    <ul>
                        <!--<li *ngFor="let subtab of events?.event; let i = index"><a href="javascript:void(0)" class="inner-name " [ngClass]="{ open: i == 0 }"  id="event-{{subtab?.event_id}}">{{subtab?.title}} </a></li>-->
                        <!-- <li><a href="javascript:void(0)" class="inner-name" id="suites-event">SUITES-event</a></li> -->
                    </ul>
                </div>
                <div class="event-conference-section  inner-main-content cf open" id="event-{{subtab?.event_id}}-contenttext" *ngFor="let subtab of events?.event; let i = index">
                    <div class="event-conference-titel">
                        <div class="titel-box">
                            <h2 class="titel-name">{{subtab?.title}}</h2>
                        </div>
                    </div>
                    <div class="event-conference-detail cf">
                        <div class="event-conference-image-slide">
                            <ngx-slick-carousel class="carousel" slickModal="slick-carousel"
                                [config]="slideconferenceConfig">
                                <div ngxSlickItem class="event-conference-image-box slide"
                                    *ngFor="let slider of subtab?.images">
                                    <img [src]="slider?.image">
                                </div>
                                <img [src]="subtab?.image">
                                <!-- <div ngxSlickItem class="event-conference-image-box slide">
                                    <img src="assets/images/conference-img.png">
                                </div> -->
                            </ngx-slick-carousel>
                        </div>
                        <div class="event-conference-content-box">
                            <div class="event-conference-content" [innerHTML]="subtab?.description">

                            </div>
                            <div class="event-conference-btn">
                                <a href="{{subtab?.btn_url_1}}" class="event-contact" *ngIf="subtab?.btn_title_1">{{subtab?.btn_title_1}}</a>&nbsp;
                                <a href="{{subtab?.btn_url_2}}" class="event-contact " *ngIf="subtab?.btn_title_2">{{subtab?.btn_title_2}}</a>&nbsp;
                                <a href="{{subtab?.btn_url_3}}" class="event-contact " *ngIf="subtab?.btn_title_3">{{subtab?.btn_title_3}}</a>
                                <a href="mailto:enquiries@leicestershireccc.co.uk" class="event-contact">Contact Us</a>&nbsp;
                            </div>
                           
                        </div>
                       
                    </div>
                </div>
                
            </div>
        </div>
        <div class="event-contact-section cf">
            <div class="event-contact-top">
                <div class="container">
                    <div class="commercial-contact-us-section cf">
                        <div class="titel-box">
                            <h2 class="titel-name">Contact us</h2>
                        </div>
                        <div class="commercial-contact-content">
                            <p>Leicestershire County Cricket Club recognises that you have a choice when it comes to booking an event. We offer a personal touch alongside our first-class facilities.</p>

                            <p>The club's Head of Events Diane Gane and Conference and Events Executive Trudi McGoldrick would be delighted to discuss your event requirements and arrange a tour of our facilities at Grace Road.</p>

                            <p *ngIf="storeurl =='conference-and-events'">Trudi McGoldrick Email -<a href="mailto:trudimcgoldrick@leicestershireccc.co.uk">  trudimcgoldrick@leicestershireccc.co.uk</a></p>
                            <!-- <p>Email -<a href="mailto:enquiries@leicestershireccc.co.uk"> enquiries@leicestershireccc.co.uk </a></p> -->
                            <p>Email -<a href="mailto:events@leicestershireccc.co.uk"> events@leicestershireccc.co.uk </a></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="commercial-bottom-contact-form" style="background-image: url(assets/images/player-bg-img.png);">
                <div class="container">
                    <div class="commercial-bottom-contact-detail">
                        <form class="commercialform " #contactusForm="ngForm" (ngSubmit)="clubContactus(contactusForm)"
                            [ngClass]="{'success': contactSuccess}">
                            <http-message types="success" [data]="contactSuccess" class="err-msg-block">
                            </http-message>
                            <http-message [type]="'error'" [data]="contactError" *ngIf="contactError"
                                class="err-msg-block"></http-message>
                            <div class="join-register-right-box">
                                <div class="join-register-right-box-input half">
                                    <app-form-field validation="required" name="first_name"
                                        [(ngModel)]="contactRequest.first_name" class="app-group">
                                        <input appFieldInput class="register-style" placeholder="First Name"
                                            type="text">
                                    </app-form-field>
                                </div>
                                <div class="join-register-right-box-input half">
                                    <app-form-field validation="required" name="last_name"
                                        [(ngModel)]="contactRequest.last_name" class="app-group">
                                        <input appFieldInput class="register-style" placeholder="Last Name" type="text">
                                    </app-form-field>
                                </div>
                                <div class="join-register-right-box-input half">
                                    <app-form-field validation="required" name="email"
                                        [(ngModel)]="contactRequest.email" class="app-group">
                                        <input appFieldInput class="register-style" placeholder="Email Address"
                                            type="text">
                                    </app-form-field>
                                </div>
                                <div class="join-register-right-box-input half">
                                    <app-form-field validation="required" name="mobile_number"
                                        [(ngModel)]="contactRequest.mobile_number" class="app-group">
                                        <input appFieldInput class="register-style" placeholder="Mobile No"
                                            type="number">
                                    </app-form-field>
                                </div>
                                <div class="join-register-right-box-input half">
                                    <app-form-field validation="required" name="company_name"
                                        [(ngModel)]="contactRequest.company_name" class="app-group">
                                        <input appFieldInput class="register-style" placeholder="Company Name"
                                            type="text">
                                    </app-form-field>
                                </div>
                                <div class="join-register-right-box-input half">
                                    <app-form-field validation="required" name="type_of_event"
                                        [(ngModel)]="contactRequest.type_of_event" class="app-group">
                                        <input appFieldInput class="register-style" placeholder="Type of event"
                                            name="type_of_event" type="text">
                                    </app-form-field>
                                </div>
                                <div class="join-register-right-box-input full">
                                    <app-form-field validation="required" name="message"
                                        [(ngModel)]="contactRequest.message" class="app-group">
                                        <textarea appFieldInput name="message" form="usrform" class="register-style"
                                            placeholder="Message">Message</textarea>
                                    </app-form-field>
                                </div>
                            </div>
                            <div class="join-register-right-box">
                                <div class="join-register-btn"><button id="reg_button" type="submit">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="commercial-bottom-contact-overlay"></div>
            </div>
        </div>
    </div>
    <!-- <div class="event-center-section course-main-content active " id="conference-event-content">
        <div class="container">
            <div class="event-center-detail cf">
                <div class="event-conference-section cf">
                    <div class="event-conference-titel">
                        <div class="titel-box">
                            <h2 class="titel-name">CONFERENCES AND EVENTS</h2>
                        </div>
                    </div>
                    <div class="event-conference-detail cf">
                        <div class="event-conference-content-box">
                            <div class="event-conference-content">
                                <p>Grace Road is a unique place where people come together in a relaxed and pleasant atmosphere.</p>
                                <p>Our members and supporters come to watch the cricket and we also offer the opportunity for everybody to enjoy our facilities.</p> 
                                <p>Whether you are holding a conference for 200 or a small meeting or 10, we have facilities to suit your needs and all of our suites boast a fantastic view of our picturesque playing fields.</p>
                                <p>If you are looking for somewhere to host your special event, we have a range of options to suit exactly what you are looking for – whether it be a wedding reception, birthday party or club dinner.</p>
                            </div>
                            <div class="event-conference-btn">
                                <a href="javascript:void(0)" class="event-contact">Contact Us</a>
                            </div>
                        </div>
                        <div class="event-conference-image-slide">
                            <ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slideconferenceConfig">
                                <div ngxSlickItem class="event-conference-image-box slide">
                                    <img src="assets/images/commercial-img.jpg">
                                </div>
                                <div ngxSlickItem class="event-conference-image-box slide">
                                    <img src="assets/images/conference-img.png">
                                </div>
                            </ngx-slick-carousel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="event-contact-section cf">
            <div class="event-contact-top">
                <div class="container">
                    <div class="commercial-contact-us-section cf">
                        <div class="titel-box">
                            <h2 class="titel-name">Contact us</h2>
                        </div>
                        <div class="commercial-contact-content" >
                            <p>Leicestershire County Cricket Club recognises that you have a choice when it comes to booking an event. We offer a personal touch alongside our first-class facilities. </p>
                            <p> The club's Catering Manager John Stew and Hospitality Manager Zoe Draycott would be delighted to discuss your event requirements and arrange a tour of our facilities at Grace Road.</p>
                            <a href="#"> e - enquiries@leicestershireccc.co.uk</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="commercial-bottom-contact-form" style="background-image: url(assets/images/contact-commercial-bg.jpg);">
                <div class="container">
                    <div class="commercial-bottom-contact-detail">
                        <div class="commercialform ">
                            <div class="join-register-right-box">
                                <div class="join-register-right-box-input half">
                                    <input class="register-style" placeholder="First Name" type="text">
                                </div>
                                <div class="join-register-right-box-input half">
                                    <input class="register-style" placeholder="Last Name" type="text">
                                </div>
                                <div class="join-register-right-box-input half">
                                    <input class="register-style" placeholder="Email Address" type="text">
                                </div>
                                <div class="join-register-right-box-input half">
                                    <input class="register-style" placeholder="Mobile No" type="number">
                                </div>
                                <div class="join-register-right-box-input half">
                                    <input class="register-style" placeholder="Company Name" type="text">
                                </div>
                                <div class="join-register-right-box-input half">
                                    <input class="register-style" placeholder="Type of event" type="number">
                                </div>
                                <div class="join-register-right-box-input full">
                                    <textarea name="comment" form="usrform" class="register-style">Message</textarea>
                                </div>
                            </div>
                            <div class="join-register-right-box">
                                <div class="join-register-btn"><button id="reg_button">Submit</button></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="commercial-bottom-contact-overlay"></div>
            </div>
        </div>
    </div> -->
    <div class="event-bottom-section cf" *ngIf="whatsNew?.data">
        <div class="container">
            <div class="event-testimonials-section cf" *ngIf="evnetList?.event_testimonials?.length > 0">
                <div class="titel-box">
                    <h2 class="titel-name">Testimonials</h2>
                </div>
                <div class="event-testimonials-detail">
                    <div class="event-testimonials-detail-slider">
                        <ngx-slick-carousel class="carousel" slickModal="slick-carousel"
                            [config]="slidetestimonialsConfig">
                            <div ngxSlickItem class="event-testimonials-slider-box slide"
                                *ngFor="let testimonial of evnetList?.event_testimonials; let i = index">
                                <div class="event-testimonials-slider-box-inner">
                                    <div class="event-testimonials-slider-content"
                                        [innerHTML]="testimonial?.description">
                                        <p>"Spearing Waite have held two internal conferences at Leicestershire County
                                            Cricket Club over the last six months, as well as attending several other
                                            events there too. The food has always been delicious and of a very high
                                            standard with customer service to match. We are always extremely well looked
                                            after and wouldn’t hesitate in recommending Leicestershire County Cricket
                                            Club as a great venue."</p>

                                    </div>
                                    <div class="event-testimonial-titel">
                                        <h3>{{testimonial?.name}} - {{testimonial?.title}}</h3>
                                    </div>
                                    <div class="event-testimonials-slider-image">
                                        <img [src]="testimonial?.image">
                                    </div>
                                </div>
                            </div>
                            <!-- <div ngxSlickItem class="event-testimonials-slider-box slide">
                                    <div class="event-testimonials-slider-box-inner">
                                        <div class="event-testimonials-slider-content">
                                            <p>"Spearing Waite have held two internal conferences at Leicestershire County Cricket Club over the last six months, as well as attending several other events there too. The food has always been delicious and of a very high standard with customer service to match. We are always extremely well looked after and wouldn’t hesitate in recommending Leicestershire County Cricket Club as a great venue."</p>
                                            <h3>Colin Blackler - Local Dental Committee</h3>
                                        </div>
                                        <div class="event-testimonials-slider-image">
                                            <img src="assets/images/testimonials-img.png">
                                        </div>
                                    </div>
                                </div> -->
                        </ngx-slick-carousel>
                    </div>
                </div>
            </div>
            <!-- <div class="event-what-on-section" *ngIf="whatsNew?.data">
                    <div class="titel-box">
                        <h2 class="titel-name">{{whatsNew?.data?.title}}</h2>
                    </div>
                    <div class="event-what-on-detail cf">
                        <div class="event-what-on-calender">
                            <div class="celender-box">
                                <div class="row text-center">
                                    <div class="col-md-4">
                                        <div class="btn-group">
                                            <div class="btn btn-primary Previous" mwlCalendarPreviousView [view]="view"
                                                [(viewDate)]="viewDate" (viewDateChange)="closeOpenMonthViewDay()">
    
                                            </div>
                                            <div class="btn btn-outline-secondary" mwlCalendarToday [(viewDate)]="viewDate">
    
                                            </div>
                                            <div class="btn btn-primary next" mwlCalendarNextView [view]="view"
                                                [(viewDate)]="viewDate" (viewDateChange)="closeOpenMonthViewDay()">
    
                                            </div>
                                        </div>
                                    </div>
                                    <div class="month-name">
                                        <h3>{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h3>
                                    </div>
                                    <div class="calendarmenu">
                                        <ul>
                                            <li class="menu-team-top">
                                                <a href="#">Add To Calender</a>                                      
                                            </li>
                                        </ul> 
                                       
                                    </div>
                                </div>
                                <br />
                                <div [ngSwitch]="view" class="date-menu">
                                    <mwl-calendar-month-view *ngSwitchCase="CalendarView.Month" [viewDate]="viewDate"
                                        [events]="events" [refresh]="refresh" [activeDayIsOpen]="activeDayIsOpen"
                                        (dayClicked)="dayClicked($event.day)"
                                        (eventClicked)="handleEvent('Clicked', $event.event)"
                                        (eventTimesChanged)="eventTimesChanged($event)">
                                    </mwl-calendar-month-view>
                                    <mwl-calendar-week-view *ngSwitchCase="CalendarView.Week" [viewDate]="viewDate"
                                        [events]="events" [refresh]="refresh"
                                        (eventClicked)="handleEvent('Clicked', $event.event)"
                                        (eventTimesChanged)="eventTimesChanged($event)">
                                    </mwl-calendar-week-view>
                                    <mwl-calendar-day-view *ngSwitchCase="CalendarView.Day" [viewDate]="viewDate"
                                        [events]="events" [refresh]="refresh"
                                        (eventClicked)="handleEvent('Clicked', $event.event)"
                                        (eventTimesChanged)="eventTimesChanged($event)">
                                    </mwl-calendar-day-view>
                                </div>
                            </div>
                        </div>
                        <div class="event-what-on-content" [innerHTML]="whatsNew?.data?.description">
                            <p>Grace Road is a unique place where people come together in a relaxed and pleasant atmosphere.</p>
                            <p>Our members and supporters come to watch the cricket and we also offer the opportunity for everybody to enjoy our facilities.</p> 
                            <p>Whether you are holding a conference for 200 or a small meeting or 10, we have facilities to suit your needs and all of our suites boast a fantastic view of our picturesque playing fields.</p>  
                            <p>If you are looking for somewhere to host your special event, we have a range of options to suit exactly what you are looking for – whether it be a wedding reception, birthday party or club dinner.</p>
                        </div>
                    </div>
                </div> -->
        </div>
    </div>
</section><!-- page ends-->